angular.module("dashboard")

    .controller('dashboardShowCtrl', ['$rootScope', '$scope', '$filter', 'LoginService', 'Restangular', '$stateParams', 'treeService', '$interval', '$http', 'filterFilter', 'logService',
        function ($rootScope, $scope, $filter, LoginService, Restangular, $stateParams, treeService, $interval, $http, filterFilter, logService) {
        $scope.totalRow = 0;
        $scope.invitedGuestNotInYet = 0;
        $scope.filterGuestsIn = 0;
        $scope.filterGuestsRejected =0;
        $scope.totalGuestNotInYet = 0;
        $scope.totalGuestIn = 0;

        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null
        }
        function isDefinedAndNotNullOrEmpty(val) {
            return angular.isDefined(val) && val !== null && val !== ""
        }

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
            $rootScope.title = $filter('translate')('dashboard.dashboard');
            $rootScope.breadcrumb = [];
        } else {
            $rootScope.title = $filter('translate')('dashboard.dashboard');
            $rootScope.breadcrumb = [{ title: $filter('translate')('dashboard.dashboard'), url: "dashboard.list" }];
        }

        Restangular.one('Events', $stateParams.id).get().then(function (results) {
            $rootScope.is_template = results.is_template;
            $scope.event = results;
            $scope.event.date_from = new Date($scope.event.date_from);
            $scope.event.date_to = new Date($scope.event.date_to);
        });

        $scope.getGuestFilters = function (guests, type) {
            if (type == 'notin') {
                var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                return filterFilter(res, { check_in_date: null }).length;
            } else if (type == 'in') {
                var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                return filterFilter(res, { check_in_date: '!!' }).length;
                //return filterFilter(guests, { confirmation_status: 'confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
            } else {
                var res = filterFilter(guests, { confirmation_status: '!confirmed' });
                return filterFilter(res, { check_in_date: '!!' }).length;
                //return filterFilter(guests, { confirmation_status: '!confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
            }
        };

        $scope.loadGuests = function () {
            var params = { event_id: $stateParams.id };
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'Events/getActualEventInfo/',
                params: params
            }).then(function (results, status, headers, config) {
                $scope.invitedGuests = results.data.rows;
                $scope.totalRow = results.data.totalRow;
                $scope.invitedGuestNotInYet = $scope.getGuestFilters($scope.invitedGuests, 'notin');
                $scope.filterGuestsIn = $scope.getGuestFilters($scope.invitedGuests, 'in');
                $scope.filterGuestsRejected = $scope.getGuestFilters($scope.invitedGuests, 'rejected');
                $scope.totalGuestNotInYet = ($scope.invitedGuestNotInYet / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);
                $scope.totalGuestIn = ($scope.filterGuestsIn / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);
            });
        };
        $scope.loadGuests();
        let intervalLoadInfoDashboard = $interval(function () { $scope.loadGuests(); }, (window as any).CONFIG.time_check_changes_guests); 

        //Cuando salga del events, se destruirá el intervalo.
        $scope.$on("$destroy", function () {
            logService.debug("Entra en el destroy del dashboard");
            if (angular.isDefined(intervalLoadInfoDashboard)) {
                $interval.cancel(intervalLoadInfoDashboard);
                intervalLoadInfoDashboard = undefined;
            }
        });

        //Grupos Por ahora nos los ponemos, siguiente version
       /* Restangular.all('Groups').getList().then(function (results) {
            var data = treeService.groups(results, null);
            $scope.groups = data;

            $scope.getvalueArray = function (item) {
                result = [];
                for (var i = 0; i < item; i++) {
                    result.push(i);
                }
                return result;
            }
        });
        // Selecciona y deselecciona a todos los hijos
        $scope.toggleCheckTree = function (item) {

            angular.forEach($scope.groups, function (child) {
                if (child.parent_group_id == item.id) {
                    child.checked = item.checked;
                    $scope.toggleCheckTree(child);
                }
            });

        }*/

         /* $scope.options = {
            user_id: LoginService.get("userId"),
            is_today_event: true
        };

      Restangular.all('Events').getList($scope.options).then(function (events) {
            $scope.events = events;
        });*/

    }])

;